import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import Rightbar from '../cheques/Rightbar'
import { PGET, GET, POST } from 'helpers/api'
import { formatMoney, formatDateBackend, returnSign, formatDate, findFromArrayById, formatDateWithTime } from 'helpers/helpers'

// FilterPagination bir sahifada 20 tadan chiqaradi.
const PAGE_SIZE = 20

function Index() {
	const { t } = useTranslation()

	const reduxReport = useSelector(state => state.report)
	const reduxAccount = useSelector(state => state.account)

	// POS ni tashqi ro'yxatdagi filtrdan olib kelamiz
	const reportClientFilter = reduxReport.reportClientFilter || {}
	const inheritedPosId = reportClientFilter.posId !== undefined ? reportClientFilter.posId : reduxAccount.posId

	const paymentTypes = [{ 'id': 1, 'name': t('CASH') }, { 'id': 2, 'name': t('TERMINAL') }, { 'id': 3, 'name': t('MONEY_TRANSFER') }]
	const currencies = [{ "id": 1, "name": "So`m" }, { "id": 2, "name": "USD" }]
	const paymentPurposes = [{ "id": 4, "name": "Долг" }, { "id": 5, "name": "Погашение задолженности" }]
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [showRightBar, setShowRightBar] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [poses, setPoses] = useState([])
	const [data, setData] = useState([])
	const [filterPoses, setFilterPoses] = useState([])
	const [totalAmount, setTotalAmont] = useState([])
	const [historyDebt, setHistoryDebt] = useState({})
	const [modalPayment, setModalPayment] = useState(false)
	const [paymentData, setPaymentData] = useState({})
	// Tartib raqami serverdan kelgan rowNum bo'yicha emas, ro'yxatdagi o'rni bo'yicha
	// chiziladi (rowNum sana bo'yicha saralanganda aralashib ketadi).
	const [page, setPage] = useState(0)
	const [filterData, setFilterData] = useState({
		startDate: null,
		endDate: null,
		posId: inheritedPosId ?? null,
		paymentPurposeId: null,
		search: '',
	})
	const [pagination, setPagination] = useState({
		url: '/services/web/api/report-client-history-pageList/' + reduxReport.reportSelectedClient.clientId,
		response: null
	})

	async function toggleRightbar(boolean = false, item, index) {
		var dataCopy = [...data]

		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[i]['showSidebar'] = false
		}

		if (item.chequeId !== 0) {
			if (boolean) {
				const response = await GET("/services/web/api/cheque-byId/" + item.chequeId, {}, { loader: true })
				dataCopy[index]['itemsList'] = response
				dataCopy[index]['showSidebar'] = boolean
				setSelectedItem(response)
				setShowRightBar(boolean)
			} else {
				setShowRightBar(boolean)
				setSelectedItem({})
			}
		}
	}

	async function payment(e) {
		e.preventDefault();

		var paymentDataCopy = { ...paymentData }

		var sendData = {}
		sendData.amountIn = paymentDataCopy.amountIn
		sendData.currencyId = paymentDataCopy.currencyId
		sendData.clientId = reduxReport.reportSelectedClient.clientId
		sendData.paymentTypeId = paymentDataCopy.paymentTypeId
		sendData.posId = paymentDataCopy.posId
		sendData.note = paymentDataCopy.note

		var response = await POST('/services/web/api/clients-payment', sendData, { loader: true })

		if (response) {
			showPaymentModal(false)
			searchWithFilter(false)
			// getData()
		}
	}

	async function showPaymentModal(bool) {
		var paymentDataCopy = {}
		if (!bool) {
			paymentDataCopy.paymentTypeId = 1
			paymentDataCopy.amountTypeId = 1
			paymentDataCopy.currencyId = 1
			paymentDataCopy.amountIn = ''
		} else {
			const response = await GET('/services/web/api/pos-helper')
			if (response) {
				setPoses(response)
			}

			paymentDataCopy.posId = response[0]['id']
			paymentDataCopy.paymentTypeId = 1
			paymentDataCopy.amountTypeId = 1
			paymentDataCopy.currencyId = 1
			paymentDataCopy.amountIn = ''
			setPaymentData(paymentDataCopy)
		}

		setModalPayment(bool)
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function searchWithFilter(exportToExcel = false, tableSort = "", overrideFilterData = null) {
		const fd = overrideFilterData || filterData
		var filterUrl = "/services/web/api/report-client-history-pageList/" + reduxReport.reportSelectedClient.clientId
		var urlParams = ""
		checkFilter(fd)

		if (fd.startDate)
			urlParams += returnSign(urlParams) + 'startDate=' + fd.startDate
		if (fd.endDate)
			urlParams += returnSign(urlParams) + 'endDate=' + fd.endDate
		if (fd.posId)
			urlParams += returnSign(urlParams) + 'posId=' + fd.posId
		if (fd.paymentPurposeId)
			urlParams += returnSign(urlParams) + 'paymentPurposeId=' + fd.paymentPurposeId
		if (fd.search)
			urlParams += returnSign(urlParams) + 'search=' + fd.search

		if (tableSort) {
			var filterDataCopy = { ...fd }
			if (filterDataCopy.tableSortKey === tableSort) {
				filterDataCopy.tableSortDirection === ',asc' ? filterDataCopy.tableSortDirection = ',desc' : filterDataCopy.tableSortDirection = ',asc'
			} else {
				filterDataCopy.tableSortDirection = ',asc'
			}
			filterDataCopy.tableSortKey = tableSort

			setFilterData(filterDataCopy)
			urlParams += returnSign(urlParams) + 'sort=' + tableSort + filterDataCopy.tableSortDirection
		}

		filterUrl = filterUrl + urlParams

		if (exportToExcel) {
			filterUrl = "/services/web/api/report-client-history-excel/" + reduxReport.reportSelectedClient.clientId + urlParams
			const response = await GET(filterUrl)
			var excelHeaders = [[t('POS'), t('CHECK_NUMBER'), t('DATE'), t('STATUS'), t('PAYMENT_METHOD'), t('CURRENCY'), t('NOTE'), t('AMOUNT_OF_DEBT'), t('PAID')]]
			for (let i = 0; i < response.length; i++) {
				var excelItems = []
				excelItems.push((i + 1) + ' ' + response[i].posName)
				excelItems.push(response[i].chequeNumber)
				excelItems.push(formatDateWithTime(response[i].createdDate))
				excelItems.push(response[i].paymentPurposeName)
				excelItems.push(response[i].paymentTypeName)
				excelItems.push(response[i].currencyName)
				excelItems.push(response[i].note)
				excelItems.push(formatMoney(response[i].amountOut))
				if (response[i].returnTotal != null) {
					excelItems.push(
						formatMoney(response[i].amountIn) + ' (' + t('APPLIED_TO_DEBT') + ') / ' +
						formatMoney(response[i].returnTotal) + ' (' + t('GOODS_RETURNED') + ')'
					)
				} else {
					excelItems.push(formatMoney(response[i].amountIn))
				}

				excelHeaders.push(excelItems)
			}
			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			styleExcelSheet(ws)
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('CLIENTS') + ".xlsx");
		} else {
			const response = await PGET(filterUrl, {}, { loader: true })
			if (response) {
				setData(response.data)
				setPagination({ ...pagination, 'url': filterUrl, 'response': response })
				setPage(0)
			}
			filterUrl = "/services/web/api/report-client-history-total/" + reduxReport.reportSelectedClient.clientId + urlParams
			const temporaryTotalAmount = await GET(filterUrl)
			setTotalAmont(temporaryTotalAmount)
			filterUrl = "/services/web/api/report-client-history-debt/" + reduxReport.reportSelectedClient.clientId + urlParams
			const temporaryHistoryDebt = await GET(filterUrl)
			setHistoryDebt(temporaryHistoryDebt)
			setDropdownIsOpen(false)
		}
	}

	function resetFilter() {
		const next = {
			startDate: null,
			endDate: null,
			posId: null,
			paymentPurposeId: null,
			search: '',
		}
		setFilterData(next)
		setFilterDataExist(false)
		searchWithFilter(false, "", next)
	}

	function checkFilter(fd = filterData) {
		if (
			!fd.startDate &&
			!fd.endDate &&
			!fd.posId &&
			!fd.paymentPurposeId &&
			!fd.search
		) {
			setFilterDataExist(false)
		} else {
			setFilterDataExist(true)
		}
	}

	async function getPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) {

			const responseCopy = [...response]
			responseCopy.unshift({ 'id': 0, 'name': t('ALL') })
			setFilterPoses(responseCopy)
		}
	}

	// async function getData() {
	// 	const response = await PGET("/services/web/api/report-client-history-pageList/" + reduxReport.reportSelectedClient.clientId, {}, { loader: true })
	// 	if (response) {
	// 		setPagination({ ...pagination, 'response': response })
	// 		setData(response.data)
	// 	}

	// 	const response2 = await GET("/services/web/api/report-client-history-total/" + reduxReport.reportSelectedClient.clientId, {}, { loader: false })
	// 	if (response2) {
	// 		setTotalAmont(response2)
	// 	}
	// 	const response3 = await GET("/services/web/api/report-client-history-debt/" + reduxReport.reportSelectedClient.clientId, {}, { loader: false })
	// 	if (response3) {
	// 		setHistoryDebt(response2)
	// 	}
	// }

	async function paginate(data, response, pageNumber = 0) {
		setPagination({ ...pagination, 'response': response })
		setData(response.data);
		setPage(pageNumber)
	}

	useEffect(() => {
		// getData()
		getPoses()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter(false)
	}, [filterData.search]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{reduxReport.reportSelectedClient.name}
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide me-2" onClick={() => searchWithFilter(true)}>
									EXCEL
								</button>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 me-2">
										{t('FILTER')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('POS')}</label>
												<Select
													options={filterPoses}
													value={filterPoses.find(option => option.id === filterData.posId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'posId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('EXPENSE_TYPE')}</label>
												<Select
													options={paymentPurposes}
													value={paymentPurposes.find(option => option.id === filterData.paymentPurposeId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'paymentPurposeId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('PERIOD')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.startDate ? new Date(filterData.startDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'startDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.endDate ? new Date(filterData.endDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'endDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('CANCEL')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter()}>{t('APPLY')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
						<div className="d-flex">
							<div className="vertical-center me-2">
								<h4>
									<b>{t('TOTAL_AMOUNT')}</b>:
								</h4>
							</div>
							<div className="vertical-center">
								{totalAmount.map((item, index) => (
									<h5 className="text-end" key={index}>
										<span className="me-1">{formatMoney(item.totalAmount)}</span>
										<b>{item.currencyName}</b>
									</h5>
								))}
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('FILTER')}</strong>
								<br />
								{(filterData.startDate || filterData.endDate) &&
									<span className="me-2">
										<b>{t('PERIOD')}: </b>
										{filterData.startDate &&
											<span>{formatDate(filterData.startDate)}</span>
										}
										{(filterData.startDate && filterData.endDate) &&
											<span>|</span>
										}
										{filterData.endDate &&
											<span>{formatDate(filterData.endDate)}</span>
										}
									</span>
								}
								{filterData.posId ?
									<span className="me-2">
										<b>{t('POS')}: </b> {findFromArrayById(filterPoses, filterData.posId)}
									</span>
									:
									''
								}
								{filterData.paymentPurposeId &&
									<span className="me-2">
										<b>{t('EXPENSE_TYPE')}: </b> {findFromArrayById(paymentPurposes, filterData.paymentPurposeId)}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('SEARCH')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('RESET')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-hover cursor mb-0">
							<thead>
								<tr>
									<th>{t('POS')}</th>
									<th className="text-center">{t('CHECK_NUMBER')}</th>
									<th className="text-center">{t('DATE')}</th>
									<th className="text-center">{t('STATUS')}</th>
									<th className="text-center">{t("PAYMENT_METHOD")}</th>
									<th className="text-center">{t('CURRENCY')}</th>
									<th className="text-center">{t('EXP_DATE')}</th>
									<th className="text-center">{t('NOTE')}</th>
									<th className="text-center">{t('ADDED_DEBT')}</th>
									<th className="text-center">{t('ADDED_PAYMENT')}</th>
									<th className="text-end">{t('BALANCE')}</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index} onClick={() => toggleRightbar(true, item, index)} className={'cursor ' + (item.showSidebar ? 'table-tr-active' : '')}>
										<td>{page * PAGE_SIZE + index + 1}. {item.posName}</td>
										<td className="text-center">{item.chequeNumber}</td>
										<td className="text-center">{formatDateWithTime(item.createdDate)}</td>
										<td className="text-center">{item.paymentPurposeName}</td>
										<td className="text-center">{item.paymentTypeName}</td>
										<td className="text-center">{item.currencyName}</td>
										<td className="text-center">{item.expDate}</td>
										<td className="text-center">{item.note}</td>
										<td className="text-center">{formatMoney(item.amountOut)}</td>
										<td className="text-center">
											{item.returnTotal != null ? (
												<>
													<div>
														{formatMoney(item.amountIn)}
														<small className="text-muted ms-1">({t('APPLIED_TO_DEBT')})</small>
													</div>
													<div>
														{formatMoney(item.returnTotal)}
														<small className="text-muted ms-1">({t('GOODS_RETURNED')})</small>
													</div>
												</>
											) : (
												formatMoney(item.amountIn)
											)}
										</td>
										<td className="text-end">{formatMoney(item.balanceAfter)}</td>
									</tr>
								))
								}
							</tbody>
						</table>
					</div>

					<div className="d-flex justify-content-between align-items-center">
						{pagination?.response &&
							<FilterPagination
								pagination={pagination}
								paginate={paginate}>
							</FilterPagination>
						}
						<div>
							<div className="d-flex my-3">
								<div className="vertical-center me-2">
									<h4>
										<b>{t('AMOUNT_OF_DEBT')}</b>:
									</h4>
								</div>
								<div className="vertical-center justify-content-between">
									{historyDebt?.debtList?.map((item, index) => (
										<h5 className="text-end" key={index}>
											<span className="me-1">{formatMoney(item.debtAmount)}</span>
											<b>{item.currencyName}</b>
										</h5>
									))}
								</div>
							</div>
							<div className="d-flex justify-content-between">
								<div className="vertical-center me-2">
									<h4>
										<b>{t('PAID')}</b>:
									</h4>
								</div>
								<div className="vertical-center">
									{historyDebt?.paidList?.map((item, index) => (
										<h5 className="text-end" key={index}>
											<span className="me-1">{formatMoney(item.debtAmount)}</span>
											<b>{item.currencyName}</b>
										</h5>
									))}
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

			<Rightbar showRightBar={showRightBar} setShowRightBar={setShowRightBar} selectedItem={selectedItem}></Rightbar>

			{/* MODAL PAYMENT */}
			<Modal show={modalPayment} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => showPaymentModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('PAY')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={payment} autoComplete="off">
						<div className="form-group">
							<label>{t('POS')}</label>
							<Select
								options={poses}
								value={poses.find(option => option.id === paymentData.posId)}
								onChange={(option) => setPaymentData({ ...paymentData, 'posId': option.id })}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('PAYMENT_METHOD')}</label>
							<Select
								options={paymentTypes}
								value={paymentTypes.find(option => option.id === paymentData.paymentTypeId)}
								onChange={(option) => setPaymentData({ ...paymentData, 'paymentTypeId': option.id })}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('CHOOSE_PAYMENT_TYPE')}</label>
							<Select
								options={currencies}
								value={currencies.find(option => option.id === paymentData.currencyId)}
								onChange={(option) => setPaymentData({ ...paymentData, 'currencyId': option.id })}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('AMOUNT')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" name="amountIn" autoFocus
								onChange={(e) => setPaymentData({ ...paymentData, 'amountIn': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('NOTE')}</label>
							<input type="text" className="form-control" name="note"
								onChange={(e) => setPaymentData({ ...paymentData, 'note': e.target.value })} />
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => showPaymentModal(false)} tabIndex="-1">{t('CANCEL')}</button>
							<button type="submit" className="btn btn-primary w-100" disabled={!paymentData.amountIn}>
								{t('SAVE')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT */}
		</>
	)
}

export default Index
